export default __webpack_public_path__ + "static/media/left-icon.7e2dc962.svg";